import riaApiClient from "@/api";
import TokenManager from "@/api/tokenManager/TokenManager"

const version = process.env.VUE_APP_API_VERSION;
const tokenManager = new TokenManager();

export default {
  namespaced: true,
  state: {
    _isUserLoggedIn: false,
    _user: {},
    _token: null,
    _testingMode: false
  },
  getters: {
    user: (state) => state._user,
    email: (state) => state._user.email,
    isUserLoggedIn: (state) => state._isUserLoggedIn,
    token: (state) => state._token,
    isAnonymous: (state) => tokenManager.isTokenAnonymous(state._token),
    testingMode: state => state._testingMode
  },
  actions: {
    async setLogged(context) {
      const response = await riaApiClient.post(`/api/${version}/login`);
      context.commit("SET_USER", response.data);
      context.commit("SET_LOGGED", true);
      
      context.dispatch('customer/setCustomer', {
        resortid: context.rootGetters['resort/resort'].id,
        customerid: response.data.id
      }, {
        root: true
      });
    },
    setToken(context, token) {
      context.commit("SET_TOKEN", token);
    },
    setTesting(context) {
      context.commit("SET_TESTING")
    },
    logoutUser(context) {
      context.commit("SET_USER", {});
      context.commit("SET_LOGGED", false);
      context.commit("SET_TOKEN", null)
      tokenManager.logout()
    }
  },
  mutations: {
    SET_TOKEN(state, accessToken) {
      state._token = accessToken
    },
    SET_USER(state, payload) {
      state._user = payload;
    },
    SET_LOGGED(state, payload) {
      state._isUserLoggedIn = payload
    },
    SET_TESTING(state) {
      state._testingMode = true
    }
  }
};
